export default {
  'result.fail.error.authorization': '请求未经授权，请重试或重新登录！',
  'result.fail.error.authorization.failed.retry': '授权已经过期，正在努力重试！',
  'result.fail.error.retry': '请求出现错误，请稍后再试'
}
